import store from "store2";
import _ from "lodash";
import { userActions as A } from "./reducer";
import DashboardApi from "../../api/DashboardApi";
import { search, getStats, getChart } from '../search/actions';
import { disconnectLiveTickets, connectLiveTickets } from '../tickets/actions';
import Axios from 'axios';
import { timers } from '../../config';

/** Actions */

/**
 * referer - the path user was trying to access but got redirected to login
 * history - react-router history object to use for redirecting without sending request to the server.
 * [CHECK] - bug?!! maybe :/
 */
export const login = ({email, password}, { referer, history }) => async (dispatch) => {
    try {
        const result = await DashboardApi.login({email, password});
    
        if(result.success === true) {
            const user = result.data.user;
    
            // add user to localstorage
            store.set('user', user);
            
            dispatch(_login(user));
            
            // dispatch search to pre get tickets
            dispatch(search());
    
            // dispatch get stats to pre get statistics
            dispatch(getStats());
            
            // dispatch get chart to pre get chart data
            dispatch(getChart());
            
            // connect to live tickets
            dispatch(connectLiveTickets());
    
            if(referer && history && typeof history.replace === "function") {
                history.replace(referer);
            }

            // remove any errors previously shown 
            dispatch(_cleanUp());
        } else {
            dispatch(_error("Invalid email/password"));
        }
    } catch (error) {
        if (Axios.isCancel(error)) {
            console.info('[LOGIN]: Previous request was cancelled!');
        } else {
            console.error(error);
            dispatch(_error("An error occured while trying to login."));
        }
    }
}

export const updateProfile = ({ name, email, old_password, new_password }, onSuccess) => async dispatch => {
    try {
        const result = await DashboardApi.updateProfile({ name, email, old_password, new_password });

        if (result.success) {
            if (typeof onSuccess === 'function') {
                const user = store.get('user');
                user.name = name;
                dispatch(_login(user));
                onSuccess();
            }
        } else {
            const code = _.get(result.data, 'error.code');

            if (code === 'invalid_password') {
                dispatch(_error('You have entered an invalid password!'));
            } else {
                dispatch(_error(result.data));
            }
        }
    } catch (error) {
        if (Axios.isCancel(error)) {
            console.info('[UPDATE_PROFILE]: Previous request was cancelled!');
        } else {
            console.error(error);
            dispatch(_error("An error occured while trying to update profile."));
        }
    }
}

export const updateAdmin = (admin, { permissions }, onSuccess) => async dispatch => {
    dispatch(_loading(true));
    try {
        const result = await DashboardApi.updateAdmin(admin, { permissions });

        if (result.success) {
            if (typeof onSuccess === 'function') {
                onSuccess();
                dispatch(_loading(false));
            }
        } else {
            const code = _.get(result.data, 'error.code');

            if (code === 'invalid_password') {
                dispatch(_error('You have entered an invalid password!'));
            } else {
                dispatch(_error(result.data));
            }
        }
    } catch (error) {
        if (Axios.isCancel(error)) {
            console.info('[UPDATE_PROFILE]: Previous request was cancelled!');
        } else {
            console.error(error);
            dispatch(_error("An error occured while trying to update profile."));
        }
    }
}

export const createAdmin = ({ name, email, password, permissions }, onSuccess) => async dispatch => {
    try {
        const result = await DashboardApi.createAdmin({ name, email, password, permissions });

        if (result.success) {
            // redirect
            if (typeof onSuccess === 'function') {
                onSuccess();
            }
        } else {
            // check error code
            if (result.data.message.includes("E11000 duplicate key error")) {
                dispatch(_error("Email already exists."));
            } else {
                dispatch(_error(result.data.message))
            }
        }

    } catch (error) {
        if (Axios.isCancel(error)) {
            console.info('[CREATE_ADMIN]: Previous request was cancelled!');
        } else {
            console.error(error);
            dispatch(_error("An error occured while trying to create admin."));
        }
    }
}

export const deleteAdmin = (id, onSuccess) => async dispatch => {
    try {
        const result = await DashboardApi.deleteAdmin(id);

        if (result.success) {
            if (typeof onSuccess === 'function') {
                onSuccess();
            }
        } else {
            const code = _.get(result.data, 'error.code') || _.get(result.data, 'message.code');

            if (code === 'delete_failed') {
                dispatch(_error('Failed to delete'));
            } else 
            if (code === 'missing_parameter') {
                dispatch(_error('ID parameter is missing'));
            }

            // clean up errors
            setTimeout(() => {
                dispatch(_error());
            }, timers.alertHide);
        }
    } catch (error) {
        if (Axios.isCancel(error)) {
            console.info('[DELETE_ADMIN]: Previous request was cancelled!');
        } else {
            console.error(error);
            dispatch(_error("An error occured while trying to delete admin."));
        }   
    }
}

export const logout = () => dispatch => {
    DashboardApi.logout();
    // remove user from local storage
    store.remove('user');

    // dispatch disconnect live tickets
    dispatch(disconnectLiveTickets());

    // clear any errors
    dispatch(_cleanUp());

    dispatch(_logout());
    window.history.pushState(null, "GB Dashboard | Login", '/login');
}

export const getAdmins = () => async dispatch => {
    dispatch(_loading(true));
    try {
        const result = await DashboardApi.getAdmins();
        if (result.success) {
            dispatch(_updateAdminsList(result.data.users, result.data.total_pages));
        } else {
            dispatch(_error(result.data));
        }
        dispatch(_loading(false));
    } catch (error) {
        dispatch(_loading(false));
        if (Axios.isCancel(error)) {
            console.info('[GET_ADMINS]: Previous request was cancelled!');
        } else {
            if (error.message === "Network Error") {
                dispatch(_error("Network error!"));    
            } else {
                console.error(error);
                dispatch(_error("Something went wrong!"));
            }
        }
    }
}

export const forgotPassword = (email) => async dispatch => {
    dispatch(_updateResetForgotPwd(A.updateForgotPwd, { loading: true }));
    if (!email) {
        return dispatch(_updateResetForgotPwd(A.updateForgotPwd, {
            loading: false,
            error: 'Please enter your email address.'
         }));
    }
    try {
        const result = await DashboardApi.forgotPassword(email);

        if (result.success === false) {
            let code = _.get(result.data, 'error.code');

            if (code === "user_not_found") {
                dispatch(_updateResetForgotPwd(A.updateForgotPwd, { loading: false, success: false, error: "User not found." }));
            } else if (code === "unauthorized") {
                dispatch(_updateResetForgotPwd(A.updateForgotPwd, { loading: false, success: false, error: "User has no authorization to use this website" }))
            } else {
                dispatch(_updateResetForgotPwd(A.updateForgotPwd, { loading: false, success: false, error: "Something went wrong!" }))
            }
        } else {
            dispatch(_updateResetForgotPwd(A.updateForgotPwd, { loading: false, success: true, error: undefined }));
        }
    } catch (error) {
        if (Axios.isCancel(error)) {
            console.info('[FORGOT_PASSWORD]: Previous request was cancelled!');
        } else {
            console.error(error);
            dispatch(_updateResetForgotPwd(A.updateForgotPwd, { loading: false, error: "An error occured while trying to send request." }));
        }
    }
}

export const resetPassword = (token, password, confirmPassword, successCallback) => async dispatch => {
    dispatch(_updateResetForgotPwd(A.updateResetPwd, { loading: true }));

    if (!password || !confirmPassword || password !== confirmPassword) {
        return dispatch(_updateResetForgotPwd(A.updateResetPwd, {
            loading: false,
            error: 'Password confirmation didn\'t match.'
         }));
    }

    try {
        const result = await DashboardApi.resetPassword(password, token);

        if (result.success === false) {
            let code = _.get(result.data, 'error.code');

            if (code === "token_invalid_or_expired") {
                dispatch(_updateResetForgotPwd(A.updateResetPwd, { loading: false, success: false, error: "Reset request is invalid or expired, try again." }));
            } else {
                dispatch(_updateResetForgotPwd(A.updateResetPwd, { loading: false, success: false, error: "Something went wrong!" }));
            }
        } else {
            dispatch(_updateResetForgotPwd(A.updateResetPwd, { loading: false, success: true, error: undefined }));
            successCallback();
        }
    } catch (error) {
        if (Axios.isCancel(error)) {
            console.info('[RESET_PASSWORD]: Previous request was cancelled!');
        } else {
            console.error(error);
            dispatch(_updateResetForgotPwd(A.updateResetPwd, { loading: false, error: "An error occured while trying to send request." }));
        }
    }
}

export const cleanUp = () => dispatch => {
    dispatch(_cleanUp());
}

/** Dispatchers */
function _login(data) {
    return {
        type: A.login,
        data: data
    }
}

function _logout() {
    return {
        type: A.logout,
    }
}

/**
 * 
 * @param {A.updateForgotPwd || A.updateResetPwd} type 
 * @param {{success: boolean, loading: boolean, error: string }} updObj 
 */
function _updateResetForgotPwd(type, updObj) {
    return {
        type: type,
        data: updObj
    }
}

function _error(error) {
    return {
        type: A.error,
        data: error
    }
}
function _loading(status) {
    return {
        type: A.loading,
        data: status
    }
}
function _updateAdminsList(list) {
    return {
        type: A.updateAdminsList,
        data: list
    }
}

function _cleanUp() {
    return {
        type: A.clean
    }
}